import { lazy } from 'react'
import { Route, Routes } from 'react-router'
import {
  AccountBankCardUrl,
  AccountDirectDepositUrl,
  AccountFavoritePlacesUrl,
  AccountFavoriteTransactionsUrl,
  AccountFavoriteTripsUrl,
  AccountImporterUrl,
  AccountPremiumUrl,
  AccountProfileUrl,
  AccountPurposesUrl,
  AccountTaxCenterUrl,
  AccountTeamUrl,
  AccountTrackerUrl,
  AccountVehiclesUrl,
  AccountWorkHoursUrl,
  DirectDepositForm
} from 'constants/RouteUrls'
import NotFoundPage from 'routes/NotFoundPage'
import { lazyLoadHelper } from 'routes/resources'
import Suspense from 'core/components/suspense/Suspense'

const TrackerPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/tracker/TrackerPage'))
)
const AccountTeamPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/team/AccountTeamPage'))
)
const FavoritePlaces = lazy(() =>
  lazyLoadHelper(() => import('pages/account/favorite-places/FavoritePlaces'))
)
const VehiclesPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/vehicles/VehiclesPage'))
)
const ImportPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/import-history/ImportPage'))
)
const TaxCenterPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/tax-center/TaxCenterPage'))
)
const FavoriteTransactionsPage = lazy(() =>
  lazyLoadHelper(
    () => import('pages/account/favorite-transactions/FavoriteTransactionsPage')
  )
)
const Profile = lazy(() =>
  lazyLoadHelper(() => import('pages/account/profile/Profile'))
)
const PurposesPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/purposes/PurposesPage'))
)
const FavoriteTrips = lazy(() =>
  lazyLoadHelper(() => import('pages/account/favorite-trips/FavoriteTrips'))
)
const WorkHours = lazy(() =>
  lazyLoadHelper(() => import('pages/account/work-hours/WorkHours'))
)
const ExpenseSyncPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/expense-sync/ExpenseSyncPage'))
)
const DirectDepositPage = lazy(() =>
  lazyLoadHelper(() => import('pages/account/direct-deposit/DirectDepositPage'))
)
const PremiumPage = lazy(() =>
  lazyLoadHelper(() => import('pages/shared/premium/PremiumPage'))
)

const MotusPageRedirect = lazy(() =>
  lazyLoadHelper(() => import('core/widgets/MotusPageRedirect'))
)

const cleanWildcard = (string: string) => {
  return string.replace('/account/', '')
}

const AccountRoutes = () => {
  return (
    <Routes>
      <Route
        path={cleanWildcard(AccountProfileUrl)}
        element={
          <Suspense variant="settings">
            <Profile />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountPurposesUrl)}
        element={
          <Suspense variant="settings">
            <PurposesPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountTrackerUrl)}
        element={
          <Suspense variant="settings">
            <TrackerPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountFavoriteTripsUrl)}
        element={
          <Suspense variant="settings">
            <FavoriteTrips />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountFavoritePlacesUrl)}
        element={
          <Suspense variant="settings">
            <FavoritePlaces />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountTaxCenterUrl)}
        element={
          <Suspense variant="settings">
            <TaxCenterPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountWorkHoursUrl)}
        element={
          <Suspense variant="settings">
            <WorkHours />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountVehiclesUrl)}
        element={
          <Suspense variant="settings">
            <VehiclesPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountBankCardUrl)}
        element={
          <Suspense variant="settings">
            <ExpenseSyncPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountDirectDepositUrl)}
        element={
          <Suspense variant="settings">
            <MotusPageRedirect
              line1="A separated window will open for you to submit"
              line2="your direct deposit information"
              path={DirectDepositForm}
              buttonText="Go to Compliance"
            >
              <DirectDepositPage />
            </MotusPageRedirect>
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountFavoriteTransactionsUrl)}
        element={
          <Suspense variant="settings">
            <FavoriteTransactionsPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountImporterUrl)}
        element={
          <Suspense variant="settings">
            <ImportPage />
          </Suspense>
        }
      />
      <Route
        path={cleanWildcard(AccountTeamUrl)}
        element={
          <Suspense variant="settings">
            <AccountTeamPage />
          </Suspense>
        }
      />
      {/*This url will show the proper billing information, cards, invoices etc*/}
      <Route
        path={cleanWildcard(AccountPremiumUrl)}
        element={
          <Suspense variant="billing">
            <PremiumPage />
          </Suspense>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AccountRoutes
